<template>


        <v-card 
        elevation="2"
        shaped
        class="ma-1"
        >
        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Champs de recherches </v-tab>
          <v-tab> Filtre de date </v-tab>
          <v-tab> Autres tables </v-tab>
          <v-tabs-items v-model="tab" class="pl-4">
            <v-tab-item>
                <v-row>
                    <v-col class="ma-1">

                        <FieldSelectionEditor
                          :fields="allFields"
                          :value="displays.params.champs"
                          label="Champs proposés dans la recherche"
                          @change="changeFields"
                          @edit="editField"
                        />

                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item>
               
                <TextField
                :item="{ name: 'nom du GET donné au champ de début', value: 'valuedeb' ,defaultprops:{ show: true }}"
                :valField="displays.params.paramdatesearch.valuedeb"
                :keyup="(item,model,selectedKey)=> { displays.params.paramdatesearch.valuedeb = model; $emit('recepVal',displays); }"
                /> 
                <TextField
                :item="{ name: 'nom du GET donné au champ de fin', value: 'valuefin' ,defaultprops:{ show: true }}"
                :valField="displays.params.paramdatesearch.valuefin"
                :keyup="(item,model,selectedKey)=> { displays.params.paramdatesearch.valuefin = model; $emit('recepVal',displays); }"
                /> 

                <SwitchC
                :item="{name: 'Recherche par date de début',value: 'deatesearch',liste: [{ text: 'OUI', value: true },{ text: 'NON', value: false }],
                defaultprops:{ show: true, column: false }}"
                :change="(item,model,selectedKey)=> { displays.params.paramdatesearch.setdebdate = model; $emit('recepVal',this.displays); }"
                :valField="displays.params.paramdatesearch.setdebdate"
                /> 

                      <TextField
                      :item="{ name: 'Nom du champ', value: 'namedeb' ,defaultprops:{ show: displays.params.paramdatesearch.setdebdate }}"
                      :valField="displays.params.paramdatesearch.namedeb"
                      :keyup="(item,model,selectedKey)=> { displays.params.paramdatesearch.namedeb = model; $emit('recepVal',displays); }"
                      /> 


                <SwitchC
                :item="{name: 'Recherche par date de fin',value: 'deatesearch',liste: [{ text: 'OUI', value: true },{ text: 'NON', value: false }],
                defaultprops:{ show: true, column: false }}"
                :change="(item,model,selectedKey)=> { displays.params.paramdatesearch.setfindate = model; $emit('recepVal',this.displays); }"
                :valField="displays.params.paramdatesearch.setfindate"
                /> 

                <TextField
                    :item="{ name: 'Nom du champ', value: 'namefin' ,defaultprops:{ show: displays.params.paramdatesearch.setfindate }}"
                    :valField="displays.params.paramdatesearch.namefin"
                    :keyup="(item,model,selectedKey)=> { displays.params.paramdatesearch.namefin = model; $emit('recepVal',displays); }"
                    /> 

    
                <SwitchC
                :item="{name: 'Recherche par mois',value: 'setmonth',liste: [{ text: 'OUI', value: true },{ text: 'NON', value: false }],
                defaultprops:{ show: true, column: false }}"
                :change="(item,model,selectedKey)=> { displays.params.paramdatesearch.setmonth = model; $emit('recepVal',this.displays); }"
                :valField="displays.params.paramdatesearch.setmonth"
                /> 
                (Pour les dates de fin et début, vous pouvez utiliser les variables [[date]])
                <TextField
                :item="{ name: 'Date de début par défaut', value: 'defaultdeb' ,defaultprops:{ show: true }}"
                :valField="displays.params.paramdatesearch.defaultdeb"
                :keyup="(item,model,selectedKey)=> { displays.params.paramdatesearch.defaultdeb = model; $emit('recepVal',displays); }"
                /> 
                <TextField
                :item="{ name: 'Date de fin par défaut', value: 'defaultfin' ,defaultprops:{ show: true }}"
                :valField="displays.params.paramdatesearch.defaultfin"
                :keyup="(item,model,selectedKey)=> { displays.params.paramdatesearch.defaultfin = model; $emit('recepVal',displays); }"
                />
            </v-tab-item>

            <v-tab-item class="pa-3">
              <p>Sélectionnez les champs proposés dans la recherche avancée. Les autocomplétions dynamiques conservent leur chargement à la saisie.</p>
              <SwitchC
                :item="{name:'Activer les filtres avancés',value:'enabled',defaultprops:{show:true}}"
                :valField="displays.params.advanced.enabled"
                :change="(item,value) => { displays.params.advanced.enabled = value; $emit('recepVal',displays); }"
              />
              <v-text-field v-if="displays.params.advanced.enabled" type="number" min="1" max="20"
                label="Nombre maximal de critères" :value="displays.params.advanced.maxconditions"
                @change="value => { displays.params.advanced.maxconditions = Math.min(20,Math.max(1,Number(value) || 20)); $emit('recepVal',displays); }" />
              <v-select v-if="displays.params.advanced.enabled" label="Combinaison par défaut"
                :items="[{text:'Toutes les conditions (ET)',value:'and'},{text:'Au moins une condition (OU)',value:'or'}]"
                :value="displays.params.advanced.defaultlogic"
                @change="value => { displays.params.advanced.defaultlogic = value; $emit('recepVal',displays); }" />
              <Autocomplete v-if="displays.params.advanced.enabled"
                :item="{name:'Champs avancés de ' + module.table,value:'advancedFields',liste:advancedMainFieldOptions,
                  defaultprops:{show:true,multiple:true,chips:true,deletablechips:true}}"
                :valField="displays.params.advanced.champs"
                :change="(item, value, key) => changeAdvancedChamps(displays.params.advanced, value, key)" />
              <v-card v-for="(source, index) in displays.params.sources" :key="index" outlined class="pa-3 mb-3">
                <v-row align="center">
                  <v-col cols="12" md="5">
                    <Select
                      :item="{ name: 'Table', value: 'table', liste: itemTableListe, defaultprops: { show: true, clearable: true } }"
                      :valField="source.table"
                      :change="(item, value) => changeSourceTable(source, value)"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <Autocomplete v-if="source.table"
                      :item="{name:'Champs avancés',value:'champs',liste:sourceFieldOptions[source.table] || [],
                        defaultprops:{show:true,multiple:true,chips:true,deletablechips:true}}"
                      :valField="source.champs"
                      :change="(item, value, key) => changeAdvancedChamps(source, value, key)" />
                  </v-col>
                  <v-col cols="12" md="1"><v-btn icon @click="removeSource(index)"><v-icon>mdi-delete</v-icon></v-btn></v-col>
                </v-row>
              </v-card>
              <v-btn small color="primary" @click="addSource">Ajouter une table</v-btn>
            </v-tab-item>

            </v-tabs-items>
        </v-tabs>
        </v-card>



</template>



<script>
import { admin } from '../mixins';
import { openFieldEditor } from '@/components/engine/editField/navigation'
    export default {
        name : 'RechModule',
        props: ["module", "page",'modalKey'],

        mixins : [admin],


        components : {
            SwitchC: () => import("../../fields/switch.vue"),
            FieldSelectionEditor: () => import('../common/FieldSelectionEditor.vue'),
        },

        data: function() {
            return { 
                valField : [],
                displays : this.module.displays,
                allFields : [],
                tab : '',
                advancedMainFieldOptions: [],
                sourceFieldOptions: {},
            }
        },


        methods : {

            addSource() {
                const template = this.buildingParameters?.search?.defaultsource || {table: '', champs: []};
                this.displays.params.sources.push(JSON.parse(JSON.stringify(template)));
                this.$emit('recepVal', this.displays);
            },
            removeSource(index) {
                this.displays.params.sources.splice(index, 1);
                this.$emit('recepVal', this.displays);
            },
            changeSourceTable(source, value) {
                source.table = value?.value || '';
                this.$set(source, 'champs', []);
                if (source.table) this.loadSourceFields(source);
                this.$emit('recepVal', this.displays);
            },
            advancedOptions(fields) {
                const hidden = ['created_by', 'deleted_at', 'created_at', 'updated_at'];
                return fields.filter(field => !hidden.includes(field.field))
                    .map(field => ({text: field.parent ? `↳ ${field.displays.name}` : field.displays.name, value: field.cle}));
            },
            changeAdvancedChamps(target, values, key) {
                target.champs = (Array.isArray(values) ? values : []).map(value =>
                    typeof value === 'object' ? value[key] || value.value || value.cle : value);
                this.$emit('recepVal', this.displays);
            },
            loadSourceFields(source) {
                this.getListField({filter:{table:source.table}}).then(fields => {
                    const options = this.advancedOptions(fields);
                    this.$set(this.sourceFieldOptions, source.table, options);
                    if (!Array.isArray(source.champs)) {
                        this.$set(source, 'champs', options.map(option => option.value));
                        this.$emit('recepVal', this.displays);
                    }
                });
            },

            editField(field) {
                if (field.create) {
                openFieldEditor({ id: field.id, onSaved: () => this.getFromAPI() })
            } else {
                openFieldEditor({ name: field.field, table: field.table, onSaved: () => this.getFromAPI() })
            }
            },
            changeFields(keys) {
                this.displays.params.champs = keys
                this.$emit('recepVal',this.displays);
            },

            getFromAPI() {
                
                this.getListField({filter:{table : this.module.table}}).then((resp) => {         

                    this.allFields = resp

                this.advancedMainFieldOptions = this.advancedOptions(resp);
                if (!Array.isArray(this.displays.params.advanced.champs)) {
                    this.$set(this.displays.params.advanced, 'champs', this.advancedMainFieldOptions.map(option => option.value));
                    this.$emit('recepVal', this.displays);
                }

                })
                
            },


        },
    
        mounted() { 
            if (!Array.isArray(this.displays.params.sources)) this.$set(this.displays.params, 'sources', []);
            if (!this.displays.params.advanced) this.$set(this.displays.params, 'advanced', {enabled:true,maxconditions:20,defaultlogic:'and'});
            this.getFromAPI()
            this.displays.params.sources.forEach(source => {
                if (source.table) this.loadSourceFields(source);
            });
            
        }

    }

</script>

